import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState, useMemo } from 'react';
import { useIntl } from 'react-intl-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import Avatar from '@atlaskit/avatar/Avatar';
import Spinner from '@atlaskit/spinner';
import { useTabPanel } from '@atlaskit/tabs';
import { messages } from '../../shared/i18n';
import { reactionViewStyle, userListStyle, userStyle, centerSpinner } from './styles';
export var ReactionView = function ReactionView(_ref) {
  var selectedEmojiId = _ref.selectedEmojiId,
    emojiProvider = _ref.emojiProvider,
    reaction = _ref.reaction;
  var intl = useIntl();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    emojiName = _useState2[0],
    setEmojiName = _useState2[1];
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var provider, emoji;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return emojiProvider;
          case 2:
            provider = _context.sent;
            _context.next = 5;
            return provider.findByEmojiId({
              shortName: '',
              id: selectedEmojiId
            });
          case 5:
            emoji = _context.sent;
            if (emoji && emoji.name) {
              setEmojiName(emoji.name);
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [emojiProvider, selectedEmojiId]);
  var alphabeticalNames = useMemo(function () {
    var _reactionObj$users;
    var reactionObj = reaction;
    return ((_reactionObj$users = reactionObj.users) === null || _reactionObj$users === void 0 ? void 0 : _reactionObj$users.sort(function (a, b) {
      return a.displayName.localeCompare(b.displayName);
    })) || [];
  }, [reaction]);
  var tabPanelAttributes = useTabPanel();
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", _extends({
      css: reactionViewStyle
    }, tabPanelAttributes), jsx("p", null, jsx(ResourcedEmoji, {
      emojiProvider: emojiProvider,
      emojiId: {
        id: selectedEmojiId,
        shortName: ''
      },
      fitToHeight: 24
    }), intl.formatMessage(messages.emojiName, {
      emojiName: emojiName
    })), alphabeticalNames.length === 0 ?
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: centerSpinner
    }, jsx(Spinner, {
      size: "large"
    })) :
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("ul", {
      css: userListStyle
    }, alphabeticalNames.map(function (user) {
      var _user$profilePicture;
      var profile = (_user$profilePicture = user.profilePicture) === null || _user$profilePicture === void 0 ? void 0 : _user$profilePicture.path;
      return (
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        jsx("li", {
          css: userStyle,
          key: user.id
        }, jsx(Avatar, {
          size: "large",
          src: profile
        }), jsx("span", null, user.displayName))
      );
    })))
  );
};